import React from 'react';
import { ButtonDropdown, ButtonDropdownProps, Icon, Popover } from '@amzn/awsui-components-react';
import CONSTANTS from 'src/utils/constants';
import { DAS_FORMULA_MENU_ITEMS, DasFormulaRow } from './DasAllocationFormulaCells';

const FIELDS = CONSTANTS.WORKSHEET_ALLOCATION_FORMULA_FIELDS;

type DasFormulaCellArgs = { row: { original: DasFormulaRow }; value?: string };

export interface DasAllocationFormulaColumnsArgs {
    viewMode: string;
    /** Disables the row menu while a save is in flight. */
    saving?: boolean;
    onMenuClick: (detail: ButtonDropdownProps.ItemClickDetails, formula: DasFormulaRow) => void;
}

const header = (label: string) => () => <div className="cell-text-non-sortable">{label}</div>;

/** Column definitions of the Step 3 formulas grid; columns without a Cell use the shared editable cell. */
export function getDasAllocationFormulaColumns({ viewMode, saving = false, onMenuClick }: DasAllocationFormulaColumnsArgs) {
    return [
        {
            accessor: 'visibleSequence',
            Header: header('#'),
            Cell: ({ row }: DasFormulaCellArgs) => (
                <div className={`save-status-${row.original.savingStatus} formulaSequence textCell`}>
                    <span className="sequenceCellValue">{row.original.visibleSequence}</span>
                </div>
            ),
        },
        { accessor: FIELDS.DESCRIPTION, Header: header('Formula name') },
        {
            accessor: FIELDS.OVERVIEW,
            Header: <div className="headerToggle">Formula overview &nbsp;
                <Popover className="calcOverviewPopover" dismissButton={false} position="right" size="small" triggerType="custom"
                         content="Click the expression to edit. Type '@' to display the autocomplete menu.">
                    <Icon name="status-info" size="small" variant="link" />
                </Popover>
            </div>,
        },
        {
            accessor: `${FIELDS.OUTPUT}Formatted`,
            Header: header('Formula output'),
            Cell: (e: DasFormulaCellArgs) => <div className="cell-text">{e.value}</div>,
        },
        { accessor: FIELDS.MAPPING, Header: header('Mapping (entity)') },
        {
            accessor: 'actions',
            Header: header(''),
            Cell: (e: DasFormulaCellArgs) => <div className="rowActions formulaOutputCell">
                {viewMode === CONSTANTS.VIEW_MODE.EDITABLE &&
                    <ButtonDropdown className={`rowContextMenu gridContextMenu dasFormulaRowAction${e.row.original.allocationFormulaId}`}
                                    onItemClick={({ detail }) => onMenuClick(detail, e.row.original)}
                                    items={DAS_FORMULA_MENU_ITEMS} disabled={saving} />
                }
            </div>,
        },
    ];
}
